import { createLovBatchFetcher } from './create-batch-fetcher'
import { createLovListFetcher } from './create-list-fetcher'
import { DEFAULT_LOV_BATCH_URL, DEFAULT_LOV_LIST_URL } from './default-fetch'

import type { LovConfigContext } from './types'

export interface HttpLovGetClient {
  get<T = unknown>(option: {
    url: string
    params?: Record<string, unknown>
  }): Promise<T>
}

export interface CreateHttpLovFetchersOptions {
  batchUrl?: string
  listUrl?: string
}

/**
 * 用 HttpRequest 创建 LOV 拉取函数。
 * GET 查询参数 `lovTypes` 为数组，需客户端支持 Spring `List<String>` 序列化（`lovTypes=a&lovTypes=b`）。
 */
export function createHttpLovFetchers(
  http: HttpLovGetClient,
  options: CreateHttpLovFetchersOptions = {}
): Pick<LovConfigContext, 'fetchLovBatch' | 'fetchLovList'> {
  const batchUrl = options.batchUrl ?? DEFAULT_LOV_BATCH_URL
  const listUrl = options.listUrl ?? DEFAULT_LOV_LIST_URL

  return {
    fetchLovBatch: createLovBatchFetcher((lovTypes) =>
      http.get({ url: batchUrl, params: { lovTypes } })
    ),
    fetchLovList: createLovListFetcher((lovType) =>
      http.get({ url: listUrl, params: { lovTypes: [lovType] } })
    ),
  }
}
